export enum SiteRoleEnum {
  Sourcer = 'SOURCER',
  Buyer = 'BUYER',
  Supplier = 'SUPPLIER',
  NoSiteAccess = 'NO_SITE_ACCESS',
}

export enum PlatformRoleEnum {
  BackendSystemAdmin = 'SYS_ADMIN',
  DataCustomerServiceAdmin = 'DATA_ADMIN',
  OrganizationAdmin = 'ORG_ADMIN',
  NoAdminAccess = 'NO_ADMIN_ACCESS',
}

export const ROLE_NAMES: { [key: string]: string } = {
  [PlatformRoleEnum.BackendSystemAdmin]: 'Back-end System Admin',
  [PlatformRoleEnum.DataCustomerServiceAdmin]:
    'Data and Customer Service Admin',
  [PlatformRoleEnum.OrganizationAdmin]: 'Organization - Admin',
  [PlatformRoleEnum.NoAdminAccess]: 'No Admin Access',
  [SiteRoleEnum.Sourcer]: 'Sourcer',
  [SiteRoleEnum.Buyer]: 'Buyer',
  [SiteRoleEnum.Supplier]: 'Supplier',
  [SiteRoleEnum.NoSiteAccess]: 'No Site Access',
};
